export const termOptions = [
  { id: "PT-1", name: "PT-I" },
  { id: "PT-2", name: "PT-II" },
  { id: "PT-3", name: "PT-III" },
  { id: "PT-4", name: "PT-IV" },
  { id: "UT-1", name: "UT-I" },
  { id: "UT-2", name: "UT-II" },
  { id: "UT-3", name: "UT-III" },
  { id: "UT-4", name: "UT-IV" },
  { id: "3", name: "Common Pre-Board" },
  { id: "4", name: "Pre-Board" },
  { id: "1", name: "Term-I" },
  { id: "2", name: "Term-II" },
  { id: "5", name: "Other" },
  { id: "6", name: "ID Cards" },
]

export const termOptionsMap = termOptions.reduce((acc, { id, name }) => {
  acc[id] = name;
  return acc;
}, {});


// Ordered term sequences used to find the "previous level" exam for a given term
// (e.g. PT-2's previous level is PT-1, Term-II's previous level is Term-I).
export const termSequences = [
  ["PT-1", "PT-2", "PT-3", "PT-4"],
  ["UT-1", "UT-2", "UT-3", "UT-4"],
  ["1", "2"], // Term-I, Term-II
  ["3", "4"], // Common Pre-Board, Pre-Board
];

// Returns the id of the term that precedes the given term in its sequence,
// or null if the term has no previous level (first in its sequence, or not part of one).
export const getPreviousTerm = (term) => {
  for (const sequence of termSequences) {
    const index = sequence.indexOf(term);
    if (index > 0) {
      return sequence[index - 1];
    }
  }
  return null;
};

export const getTermLabel = (term) => {
  const termMapping = {
    "UT-1": "UT-I",
    "UT-2": "UT-II",
    "UT-3": "UT-III",
    "UT-4": "UT-IV",
    "PT-1": "PT-I",
    "PT-2": "PT-II",
    "PT-3": "PT-III",
    "PT-4": "PT-IV",
    "1": "Term-I",
    "2": "Term-II",
    "3": "Common Pre-Board",
    "4": "Pre-Board",
    "5": "Other",
    "6": "ID Cards",
  };

  return termMapping[term] || null;
};



